import { render, staticRenderFns } from "./DidTemplates.vue?vue&type=template&id=5b61d418&scoped=true&"
import script from "./DidTemplates.vue?vue&type=script&lang=js&"
export * from "./DidTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b61d418",
  null
  
)

export default component.exports